import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsOptional,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import { SubdivisionUpdateDto } from './subdivision-update.dto';

export const SUBDIVISION_SUPERVISOR_MAX_ITEMS = 200;

/**
 * Body of PATCH /subdivision/:id/with-supervisors. Omitted keys are left
 * untouched; the two id lists are desired sets diffed server-side. A
 * subdivision always keeps at least one supervisor.
 */
export class SubdivisionWithSupervisorsDto {
  @ApiPropertyOptional({ type: () => SubdivisionUpdateDto })
  @Expose()
  @IsOptional()
  @ValidateNested()
  @Type(() => SubdivisionUpdateDto)
  subdivision?: SubdivisionUpdateDto;

  @ApiPropertyOptional({
    type: [String],
    format: 'uuid',
    description:
      'Desired set of Supervisor user ids; each must hold the Supervisor role and belong to the subdivision region.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(SUBDIVISION_SUPERVISOR_MAX_ITEMS)
  @IsUUID('4', { each: true })
  supervisorUserIds?: string[];

  @ApiPropertyOptional({
    type: [String],
    format: 'uuid',
    description:
      'Desired set of BuilderSupervisor user ids; each must hold the BuilderSupervisor role and belong to the subdivision region.',
  })
  @Expose()
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(SUBDIVISION_SUPERVISOR_MAX_ITEMS)
  @IsUUID('4', { each: true })
  builderSupervisorUserIds?: string[];
}
